import { createContext, use } from 'react'

import type { DropdownList } from './dropdownFloating'
import type { DropdownHtmlProps } from './DropdownMenuContext'
import type { DropdownPanelFloating } from './DropdownPanel'
import type { DropdownMenuSearch } from './DropdownSearch'

type DropdownSubMenuContextValue = {
    open: boolean
    /** Shared by the trigger's aria-haspopup and the panel's role, so the two cannot disagree. */
    role: 'menu' | 'dialog'
    /** What the content panel is positioned and wired with. */
    floating: DropdownPanelFloating
    /** The trigger row's side of the floating-ui instance. */
    setReference: (node: HTMLElement | null) => void
    getReferenceProps: (userProps?: DropdownHtmlProps) => Record<string, unknown>
    list: DropdownList
    /** The search field the submenu was given, which its content panel renders. */
    search: DropdownMenuSearch | undefined
    /**
     * Whether this panel opened as a hand-off from a sibling submenu, which appears as the pointer moving
     * down a column of triggers. Animating each one in turn reads as flicker, so the hand-off is instant.
     */
    openedAsHandoff: boolean
}

export const DropdownSubMenuContext = createContext<DropdownSubMenuContextValue | null>(null)

export function useDropdownSubMenuContext() {
    const context = use(DropdownSubMenuContext)
    if (!context) throw new Error('AstraDropdownMenuSubTrigger and AstraDropdownMenuSubContent must be rendered inside an AstraDropdownMenuSub')
    return context
}
